import { ValueOf } from "../type";

export const MyOrganizationKey = {
  MyOrganizations: "MY_ORGANIZATIONS",
  MyOrganizationById: "MY_ORGANIZATION_BY_ID",
} as const;

export type MyOrganizationKeyType = ValueOf<typeof MyOrganizationKey>;
